export const getLoteId = (loteOrId) => {
   if (loteOrId == null || loteOrId === '') return null;
   if (typeof loteOrId === 'object') {
      const id = loteOrId.id ?? loteOrId.id_lote;
      if (id == null || id === '') return null;
      const numericId = Number(id);
      return Number.isNaN(numericId) ? null : numericId;
   }
   const numericId = Number(loteOrId);
   return Number.isNaN(numericId) ? null : numericId;
};

export const loteIdsMatch = (a, b) => {
   const idA = getLoteId(a);
   const idB = getLoteId(b);
   return idA != null && idB != null && idA === idB;
};

export const getAdicionalesFromLote = (lote = {}) => ({
   helada: Boolean(lote.helada),
   viento: Boolean(lote.viento),
   planchado: Boolean(lote.planchado),
   incendio_rastrojo: Boolean(lote.incendio_rastrojo),
});

export const findPlanLote = (selectedPlan, lote) =>
   selectedPlan?.lotes?.find((pl) => loteIdsMatch(pl.lote, lote)) ?? null;

export const buildLotesAdicionalesPayload = (lotes, selectedPlan) => {
   if (!Array.isArray(lotes)) return [];
   return lotes
      .map((lote) => {
         const planLote = findPlanLote(selectedPlan, lote);
         const producto = planLote?.productos?.[0];
         if (!planLote || !producto) return null;
         return {
            id_lote: getLoteId(lote),
            id_producto: producto.id_producto,
            ...getAdicionalesFromLote(lote),
         };
      })
      .filter(Boolean);
};

export const applyAdicionalesToPlanLotes = (plan, storeLotes) => {
   if (!plan?.lotes || !Array.isArray(storeLotes)) return plan;
   return {
      ...plan,
      lotes: plan.lotes.map((item) => {
         const storeLote = storeLotes.find((l) => loteIdsMatch(l, item.lote));
         if (!storeLote) return item;
         return {
            ...item,
            lote: {
               ...item.lote,
               ...getAdicionalesFromLote(storeLote),
            },
         };
      }),
   };
};

export const applySwitchToPlan = (plan, loteId, switchType, value) => {
   if (!plan?.lotes) return;
   const planIndex = plan.lotes.findIndex((item) =>
      loteIdsMatch(item.lote, loteId),
   );
   if (planIndex === -1 || !plan.lotes[planIndex].lote) return;
   plan.lotes[planIndex].lote[switchType] = value;
};
